<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8" class="mt-4">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <h1>Masuk</h1>
                  <p class="text-muted">Masuk ke akun Anda</p>
                  <CAlert
                    color="danger"
                    closeButton
                    :show.sync="alert.show"
                  >
                    <small>{{ alert.content }}</small>
                  </CAlert>
                  <CInput
                    placeholder="Email"
                    type="email"
                    v-model="data.email"
                    :invalid-feedback="errors.email ? errors.email[0]:''"
                    :is-valid="errors.email ? false:null"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    v-model="data.password"
                    :invalid-feedback="errors.password ? errors.password[0]:''"
                    :is-valid="errors.password ? false:null"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">  
                        <ButtonLoader 
                          :loading="loading.submit" 
                          :styled="'btn btn-primary btn-block'" 
                          @click.native="submit()">
                            Masuk
                        </ButtonLoader>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0" @click="$router.push({name: 'Forget'})">Lupa Password</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5"
              body-wrapper
            >
              <CCardBody>
                <h2>WebSMS</h2>
                <p>Membutuhkan Layanan API SMS Sender paling MURAH dan paling CEPAT!! WebSMS Solusinya, penyedia layanan API SMS Sender paling bisa di andalkan!!<br><br>KIRIM, LANGSUNG DIPROSES!!</p>
                <CButton color="light" variant="outline" size="lg" @click="$router.push({name: 'Register'})">
                  Daftar Sekarang!
                </CButton>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import $axios from './../../api.js'
export default {
  name: 'Login',
  data(){
    return{
      alert:{
        show: false,
        content: ''
      },
      loading:{
        submit: false
      },
      data:{
        email: '',
        password: ''
      }
      
    }
  },
  created(){
    if (this.isAuth) {
      this.$router.push({ name: 'Home' })
    }
  },
  computed:{
    ...mapState(['errors']),
    ...mapGetters(['isAuth']),
  },
  methods:{
    submit(){
      localStorage.setItem('token', null)
      this.$store.commit('SET_TOKEN', null, { root: true })
      this.$store.commit('CLEAR_ERRORS')
      this.loading.submit = true
      $axios.post('/auth/login', this.data)
      .then((response) => {
        if(response.data.status == true) {
            localStorage.setItem('token', response.data.access_token)
            this.$store.commit('SET_TOKEN', response.data.access_token, { root: true })
            this.$store.commit('SET_CUSTOMER', response.data.data, { root: true })
        }else{
          this.alert = {
            show: true,
            content: response.data.message
          }
        }
        if (this.isAuth) {
          this.$router.push({ name: 'Home'})
        }else{
          this.$router.push({ name: 'Auth' }).catch(()=>{})
        }
        this.loading.submit = false
      })
      .catch((error) => {
        this.loading.submit = false
        if(error.response.status == 422) {
          this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
        }else{
          this.alert = {
            show: true,
            content: error.response.data.message
          }
        }
        
      })
    }
  },
  destroyed(){
    this.$store.commit('CLEAR_ERRORS')
  }
}
</script>
